import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { PropertyProviderDisplaySetModel } from '../models/property-provider-display-set.model';
import { Observable, of } from 'rxjs';
import { PropertyProvidersService } from '../services/property-providers.service';

@Injectable({
  providedIn: 'root'
})
export class PropertyProvidersDisplaySetResolver implements Resolve<Array<PropertyProviderDisplaySetModel>> {
  constructor(private service: PropertyProvidersService, private router: Router) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<PropertyProviderDisplaySetModel>> {
        return this.service.GetProvidersDisplaySet();                
    }
}